export const unwrapNewsletterContent = (wrappedContent) => {
    // Regular expression to match the content inside <div class="content" style="overflow-x: auto; padding: 20px;">
    const contentRegex = /<div class="content" style="overflow-x: auto; padding: 20px;">([\s\S]*?)<\/div>/i;
    const match = wrappedContent.match(contentRegex);
    return match && match[1] ? match[1].trim() : wrappedContent;
};